import React from 'react';

import ApplicationReceivedReadOnly from './ReadOnlyMode';
import ApplicationReceivedEditMode from './EditMode';

export default function ApplicationReceived({
  editMode,
  setEditMode,
  date,
  time,
  dateTime,
  setDate,
  setTime,
  handleSave,
  loading = false,
  data,
  applicationReceivedEditAllowed,
}) {
  const toggleEditMode = () => {
    setEditMode((prev) => !prev);
  };
  return editMode ? (
    <ApplicationReceivedEditMode
      toggleEditMode={toggleEditMode}
      date={date}
      time={time}
      dateTime={dateTime}
      setDate={setDate}
      setTime={setTime}
      handleSave={handleSave}
      loading={loading}
    />
  ) : (
    <ApplicationReceivedReadOnly
      data={data}
      toggleEditMode={toggleEditMode}
      applicationReceivedEditAllowed={applicationReceivedEditAllowed}
    />
  );
}
